import Link from "next/link";
import { ArrowLeft } from "lucide-react";

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-2xl px-4 py-8">
        <Link
          href="/auth/signup"
          className="mb-6 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Link>

        <h1 className="text-3xl font-bold">Terms of Service</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Last updated: February 2026
        </p>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">1. Acceptance of Terms</h2>
            <p>
              By accessing or using RateRight (&ldquo;the Platform&rdquo;), you agree to be bound by these Terms of
              Service. If you do not agree, do not use the Platform.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">2. About RateRight</h2>
            <p>
              RateRight is a construction hiring marketplace that connects contractors with
              skilled workers. We are not a labour hire company. We provide a technology platform
              to facilitate direct connections between parties.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">3. User Accounts</h2>
            <p>
              You must provide accurate information when creating an account. You are responsible for
              maintaining the security of your account credentials. You must be at least 18 years old
              to use the Platform.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">4. Fees</h2>
            <p>
              Workers can use the Platform for free. Contractors pay a flat fee of $50 AUD per
              successful hire made through the Platform. Payment is processed via Stripe.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">5. Worker Responsibilities</h2>
            <p>
              Workers must hold valid certifications (including a White Card) as required by
              Australian law. Workers are responsible for ensuring their qualifications and
              availability information is accurate and up to date.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">6. Contractor Responsibilities</h2>
            <p>
              Contractors must hold a valid ABN and comply with all applicable employment laws,
              including WHS obligations. The employment relationship is between the contractor
              and the worker — RateRight is not a party to any employment arrangement.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">7. Limitation of Liability</h2>
            <p>
              RateRight is provided &ldquo;as is&rdquo;. We do not guarantee the quality, reliability, or
              suitability of any worker or contractor. To the maximum extent permitted by law,
              we are not liable for any loss or damage arising from use of the Platform.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">8. Termination</h2>
            <p>
              We may suspend or terminate your account at any time for breach of these terms
              or for any other reason at our discretion.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">9. Governing Law</h2>
            <p>
              These terms are governed by the laws of New South Wales, Australia.
            </p>
          </section>

          <section>
            <h2 className="mb-2 text-lg font-semibold text-foreground">10. Contact</h2>
            <p>
              For questions about these terms, contact us at support@rateright.com.au.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
